<template>
  <div>
    <h3 class="title dw_green--text font-weight-light">
      <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiAbacus" />
      CAPEC&trade; Attack Patterns
    </h3>
    <v-row no-gutters>
      <v-col cols="11">
        <v-text-field
          v-model="search"
          @change="searchExisting"
          @click:clear="search = ''; searchExisting()"
          label="Search Attack Patterns"
          :append-icon="mdiMagnify"
          color="dw_green"
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card width="33vw" max-height="50vh" class="pa-2 my-2 existing-list">
      <p v-for="capec of capecs" :key="capec" class="grey--text caption mb-1">{{ capec }}</p>
    </v-card>
  </div>
</template>

<script>
import { mdiAbacus, mdiMagnify } from '@mdi/js';
import { mapGetters } from 'vuex';

export default {
  name: 'capecList',
  data() {
    return {
      mdiAbacus,
      mdiMagnify,
      search: '',
      capecs: []
    }
  },
  computed: {
    ...mapGetters([
      'capecOptions'
    ])
  },
  mounted() {
    this.capecs = this.capecOptions.map((capec) => `CAPEC-${capec.id} ${capec.name}`);
  },
  methods: {
    searchExisting() {
      this.capecs = this.capecOptions.map((capec) => capec.name);
      if (this.search !== '') {
        this.capecs = this.capecs.filter((capec) => {
          const s = this.search.toLowerCase();
          return capec.toLowerCase().includes(s);
        });
      }
    }
  }
};
</script>

<style scoped>
.existing-list {
  height: inherit;
  overflow-y: scroll;
}
</style>
